import { create } from 'zustand'
import { combine } from 'zustand/middleware'
import { persist } from 'zustand/middleware'

import {
  resetGroupsStoreAction,
  setSelectedGroupIdAction,
  setTempSelectedGroupIdAction,
  setTempSelectedObjectiveIdAction,
} from '@/features/groups/stores/groups/groups.actions'
import subscribeToStore from '@/lib/zustand'

export type GroupsStoreValuesType = {
  selectedGroupId: string | null
  // temporary selected group id to be used when creating a new session from a conversation for example
  // this value is reset when exiting the session creation modal
  tempSelectedGroupId: string | null
  // temporary selected objective id to pre-select objective when creating a session from dashboard
  tempSelectedObjectiveId: string | null
}

export const INITIAL_MENTORSHIP_GROUPS_STORE_VALUES: GroupsStoreValuesType = {
  selectedGroupId: null,
  tempSelectedGroupId: null,
  tempSelectedObjectiveId: null,
}

export const MENTORSHIP_GROUPS_STORAGE_KEY = 'groups'

const groupsStore = subscribeToStore(
  create(
    persist(
      combine(INITIAL_MENTORSHIP_GROUPS_STORE_VALUES, (set, get) => ({
        setSelectedGroupId: (groupId: string | null) => setSelectedGroupIdAction(get, set, groupId),
        setTempSelectedGroupId: (groupId: string | null) => setTempSelectedGroupIdAction(get, set, groupId),
        setTempSelectedObjectiveId: (objectiveId: string | null) => setTempSelectedObjectiveIdAction(get, set, objectiveId),

        reset: () => resetGroupsStoreAction(set),
      })),
      {
        name: MENTORSHIP_GROUPS_STORAGE_KEY, // unique name to store the data under in local storage
        // we do not persist the tempSelectedGroupId because it is used to filter sessions
        partialize: (state) => ({
          selectedGroupId: state.selectedGroupId,
        }),
      },
    ),
  ),
)
export default groupsStore
